<template>
  <router-view :formData.sync="formData"></router-view>
</template>

<script>
export default {
  data () {
    return {
      formData: {
        kiyk_cd: null,
        kki_cd: null,
        bhn_id: null,
        bhn_num: '',
        sum_typ: '',
        kukn_kikk_val: '',
        kukn_sish_val: '',
        kukn_dt: '',
        kukn_tm: '00:00',
        bhn_cd_snk: '',
        bhn_nm_snk: '',
        bhn_num_snk: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/HshTnknMstr/HshTnknMstrSnkTurkPrnt.vue